import { theme } from '../../styles/theme';

export const startJourneyContainer = {
  padding: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
};
export const startJourneyTitle = {
  fontSize: '20px',
  fontWeight: 600,
  paddingBottom: '40px',
  textAlign: 'center'
};
export const startJourneySteps = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  justifyContent: 'center'
};

export const startJourneyImage = {
  height: {
    mobile: '100px',
    tablet: '135px'
  }
};

export const startJourneyTime = {
  fontWeight: 600,
  wordBreak: 'break-word',
  fontSize: '14px'
};

export const startJourneyStepContainer = {
  textAlign: 'center',
  width: {
    tablet: 'calc(25% - 20px)',
    mobile: '100%'
  }
};

export const startJourneyDescription = {
  fontWeight: 400,
  fontSize: '14px',
  color: theme.palette.common.darkBlue2
};

export const startJourneyDownloadLink = {
  display: 'inline',
  textDecoration: 'underline',
  color: theme.palette.common.textInteractiveBrand,
  cursor: 'pointer'
};
